import { type FC, memo } from 'react';

import { Button, ButtonStyle } from '@atlas/components';

import { License } from 'components/Licenses';
import StaticBlock from 'components/StaticBlock';
import { useConfig } from 'config';
import { getMediaUrl } from 'utils/assets';
import { Translation } from 'utils/translations';

import styles from './Footer.module.scss';

const Footer: FC = memo(() => {
  const { logo, name } = useConfig('config.siteConfig.general');
  const staticBlockName = useConfig('config.siteConfig.footer.banner');
  const year = new Date().getFullYear();
  const licenses = useConfig('config.siteConfig.licenses.list') || [];
  const enabledLicenses = licenses.filter((license) => license.enabled);

  return (
    <footer className={styles.wrapper}>
      {enabledLicenses.length > 0 && (
        <div className={styles.licenses}>
          {enabledLicenses.map((license) => (
            <License key={license.name} {...license} />
          ))}
        </div>
      )}
      <StaticBlock name={staticBlockName} />
      <mark>
        <img
          src={getMediaUrl(logo, 'cms')}
          alt="BetMelon"
          className={styles['footer-logo']}
        />
        <div className={styles.copyright}>
          &copy; {year} {name} | <Translation message="all_rights_reserved" />
        </div>
      </mark>
      <Button
        style={ButtonStyle.outline}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <Translation message="back_to_top" />
      </Button>
    </footer>
  );
});

export default Footer;
